import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const documentsApi = axios.create({
  baseURL: `${API_URL}/documents`,
  headers: { 'Content-Type': 'application/json' },
});

documentsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const documentService = {
  approve: async (id) => (await documentsApi.put(`/${id}/approve`)).data,
};

export default documentService;



